import { ARRAY_EMPTY } from '@libs/constants';

import { useFastGameCtx } from '@features/game/providers/FastGameProvider';

import { PairingSearch } from './PairingSearch';

export function PairingSearchWidget({
  className,
  isAuthenticated,
}: {
  className?: string;
  isAuthenticated: boolean;
}) {
  const { pools, selected, select } = useFastGameCtx();

  return (
    <PairingSearch
      className={className}
      selectedPools={selected}
      poolStats={pools || ARRAY_EMPTY}
      onPoolsChange={select}
      isAuthenticated={isAuthenticated}
    />
  );
}
